import React from "react";
import { useLang } from "@/context/LangContext";

export const LangToggle = ({ className = "" }) => {
  const { lang, setLang } = useLang();
  const seg = (code, label) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      className={`px-2.5 h-7 rounded-full text-xs font-bold transition-colors ${lang === code ? "bg-primary text-white shadow" : "text-muted-foreground hover:text-foreground"}`}
      data-testid={`lang-${code}`}
      aria-pressed={lang === code}
    >
      {label}
    </button>
  );
  return (
    <div className={`inline-flex items-center gap-0.5 h-9 rounded-full border border-primary/40 bg-secondary/80 p-1 notranslate ${className}`} dir="ltr" translate="no" data-testid="lang-toggle">
      {seg("en", "EN")}
      {seg("ar", "AR")}
    </div>
  );
};
